module.exports = __webpack_public_path__ + "img/Thumbs up Icon - charcoal.6917966a.svg";